import React from 'react';
import { Link } from 'react-router-dom';

export const COIN_SCORE_BANDS = [
  { range: '< 1.00', label: 'Weak', className: 'coin-band-weak' },
  { range: '1.00-1.24', label: 'Solid', className: 'coin-band-speculative' },
  { range: '1.25-1.49', label: 'Good', className: 'coin-band-watchlist' },
  { range: '1.50-2.00', label: 'Strong', className: 'coin-band-strong' },
  { range: '2.01+', label: 'Elite', className: 'coin-band-elite' }
];

const CoinScoreLegend = () => (
  <section className="coin-score-legend" aria-labelledby="coin-score-legend-title">
    <div className="coin-score-legend-header">
      <h2 id="coin-score-legend-title">COIN Score Scale</h2>
      <Link to="/faq" className="coin-score-legend-link">Learn</Link>
    </div>
    <div className="coin-score-meter" aria-label="COIN Score range legend">
      {COIN_SCORE_BANDS.map((band) => (
        <div className={`coin-score-band ${band.className}`} key={band.range}>
          <span className="coin-score-band-range">{band.range}</span>
          <span className="coin-score-band-label">{band.label}</span>
        </div>
      ))}
    </div>
  </section>
);

export default CoinScoreLegend;
